<div class="grid grid-cols-1 items-center gap-x-4 gap-y-2 rounded-xl bg-gray-light p-6 desk:grid-cols-[316px_auto]">
  @if (title(); as title) {
    <app-title [title]="title" [size]="size()" />
  }
  @if (text(); as text) {
    <div [innerHTML]="text" class="prose prose-custom-marker leading-tight" handleHtmlLinks></div>
  }
</div>
